/**
 * Operation Configuration resource
 *
 * @name OperationConfiguration
 * @class
 * @augments TmrResource
 */
export const factory = [
  'OperationConfiguration',
  /*@ngInject*/ (TmrResource, Role) => {
    const references = [{ property: 'role', resource: Role }]
    const defaultValues = () => ({
      attributes: {
        'tmr.operation.config.reading.mode': 'rfid',
        'tmr.operation.config.enableRfidCheck': 'yes',
        'tmr.operation.config.inbound.mode': 'parcelByParcel',
        'tmr.operation.config.outbound.mode': 'parcelByParcel',
        'tmr.operation.config.itemvalidation': 'decode',
        'tmr.operation.config.missing.confirm': 'withWarning',
        'tmr.operation.config.overqty.confirm': 'withWarning',
        'tmr.operation.config.unexpected.confirm': 'withWarning',
        'tmr.operation.config.remove.mode': 'sku',
        'tmr.operation.config.createChecklistType': 'item',
        'tmr.operation.config.unknownItemsAction': 'createItemIfProductExist',
        'tmr.operation.config.confirmmode': 'sync',
        'tmr.operation.config.hideParcelInput': 'no',
        'tmr.operation.config.hideShipmentInput': 'no',
        'tmr.operation.config.hideDestinationInput': 'no',
        'tmr.logistics.encoding.identifiers.exist.validate': 'true',
        'tmr.logistics.encoding.initial.type': null,
        'tmr.logistics.encoding.nextepc.filter': null,
        'tmr.logistics.encoding.nextepc.gs1': 'true',
        'tmr.logistics.encoding.nextepc.partition': null,
        'tmr.logistics.encoding.productionorder.validate': 'true',
        'tmr.logistics.encoding.productionorder.worker.validate': 'true',
        'tmr.logistics.encoding.serial.productCode': 'true',
        'tmr.logistics.encoding.write.enable': 'false',
        'tmr.operation.config.readings.displayMode': 'groupedByProduct',
        'tmr.operation.config.item.error.states': null,
        'tmr.operation.config.item.warning.states': null,
        'tmr.operation.config.item.ignore.states': null,
        'showListOnStart': 'yes',
      },
      clients: [],
      places: [],
      priority: 0,
    })
    return TmrResource(
      'OperationConfiguration',
      null,
      references,
      defaultValues
    )
  },
]
